export class NotificationSound {
  private buzzer: { play: () => void; stop: () => void } | null = null

  constructor() {
    if (!IS_BROWSER) throw new Error('NotificationSound can only be used in browser')
    void Promise.all([
      import('buzz').then(m => m.default),
      import('@app/assets/sounds/notification.ogg').then(m => m.default),
      import('@app/assets/sounds/notification.mp3').then(m => m.default),
    ]).then(([buzz, notification_ogg, notification_mp3]) => {
      if (buzz.isSupported()) {
        try {
          this.buzzer = buzz.sound([notification_ogg, notification_mp3], {
            preload: true,
            loop: false,
          })
        } catch {}
      }
    })
  }

  play() {
    try {
      this.buzzer?.play()
    } catch {}
  }

  stop() {
    this.buzzer?.stop()
  }
}
